module.exports = __webpack_public_path__ + "img/e_3_11_g.98ee1ae0.png";